import { z } from 'zod';
import type { Gender } from '../enums.js';

export interface InstitutionMember {
  id: string;
  practitioner: {
    id: string;
    email: string;
    profile: {
      gender: Gender;
      first_name: string;
      last_name: string;
      phone: string | null;
      avatar_url: string | null;
    } | null;
  };
  created_at: string;
  updated_at: string;
}

export const institutionMemberParamsSchema = z.object({
  user_id: z.uuid('Valid user ID is required'),
});

export type InstitutionMemberParams = z.infer<typeof institutionMemberParamsSchema>;
